import Cookies from 'js-cookie'
import Vue from 'vue';

const cookieExpires = 1
let vm = new Vue();
export const TOKEN_KEY = 'token'

/**
 * 对axios返回的数据进行if判断
 * @param res
 * @param success
 * @param reject
 */

 export const logic = ( res, success, reject ) => {
  if ( res.data.status === 'success' ) {
        /**
         * 请求成功，返回数据
         */
         success && success( res.data.data );
    } else if ( res.data.status === 'fail' ) {
        /**
         * 请求被拒绝，返回错误信息
         */
        vm.$message.warning(res.data.message);
        reject && reject( res.data.errorMsg );
    } else {
        vm.$message.warning(res.data.message);
  }
}

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

// const showThisMenuEle = (item, access) => {
//   if (item.meta && item.meta.access && item.meta.access.length) {
//     if (hasOneOf(item.meta.access, access)) return true
//     else return false
//   } else return true
// }
/*
 * 判断当前字符是否大于0 
 * @method isGoUp
 * @param {string} numStr 要传入的是一个数字字符串
 * @return {boolean} 返回的是当前字符串内的数字是否大于0
*/
export let isGoUp = (numStr) => {
  return +numStr >= 0;
}

/*
 * 截取小数点后两位
 * @method  twoDecimalPlaces
 * @param {string} numStr 要传入的是一个数字字符串

 * @return {boolean} 返回的是当前字符串内的数字是否大于0
*/
export let twoDecimalPlaces = (str) => {
  if (isNaN(str)) {
    return '请传入数字字符串';
  } else {
    if (str.indexOf('.') > 0) {
      return (+str).toFixed(2);
    } else {
      return (+str)
    }
  }
}
/**
 * 判断一个对象是否为空的
 */
export let objectIsEmpty = (obj) => {
  if (typeof obj === "object" && !(obj instanceof Array)) {
    var hasProp = false;
    for (var prop in obj) {
      hasProp = true;
      break;
    }
    if (hasProp) {
      obj = [obj];
      return true
    } else {
      return false;
    }
  }
}

/*
 * 截取小数点后两位
 * @method 
 * @param {string} numStr 要传入的是一个代表秒数的数字字符串  如  ('61')
 * @return {boolean} 返回的是当前字符串转化为时间格式  如 ('01:01')
*/
export let strToTimeStr = (str) => {
  let minuteStr = Math.floor(+str / 60);
  let secondStr = +str % 60;
  minuteStr = minuteStr < 10 ? '0' + minuteStr : minuteStr;
  secondStr = secondStr < 10 ? '0' + secondStr : secondStr;
  return minuteStr + ':' + secondStr;
}
/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}


// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}


export function scrollLoad (callback) {
  return () => {
    // 下拉加载
    const pageHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight
    );
    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      0;
    const scrollHeight =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (pageHeight - viewportHeight - scrollHeight < 20) {
      callback && callback();
    }
  };
}

function igpGoToLogin() {}

window.igpGoToLogin = igpGoToLogin;

export function getAppIgpGoToLogin() {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  var data = null;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    if (window.android) {
      console.log("进入安卓登录");
      data = window.android.igpGoToLogin();
    }
  } else if (isiOS) {
    console.log("进入ios登录");
    data = window.igpGoToLogin();
  }
  return data;
}


/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
// export const setTitle = (routeItem, vm) => {
//   const handledRoute = getRouteTitleHandled(routeItem)
//   const pageTitle = showTitle(handledRoute, vm)
//   const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
//   window.document.title = resTitle
// }
